import { createReducer, on } from '@ngrx/store';

import { StockToteAction } from './stock-tote.action';
import { StockToteListPagination } from '../models/stock-tote-list.model';
import { StockToteSummaryResponse } from '../models/stock-tote.model';
export const stockToteKey = 'stockTote';

export interface StockToteState {
  stockToteSummary: StockToteSummaryResponse;
  stockToteListPagination: StockToteListPagination;
}

export const initialState: StockToteState = {
  stockToteSummary: null,
  stockToteListPagination: null
};

export const stockToteReducer = createReducer<StockToteState>(
  initialState,
  on(StockToteAction.stockToteSummaryResponse, (state, response) => {
    return { ...state, stockToteSummary: response.response };
  }),
  on(StockToteAction.stockToteListResponse, (state, response) => {
    return { ...state, stockToteListPagination: response.response };
  })
);
